import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/spaces/$spaceId/pages/$pageId')({
  component: SubPageLayout,
});

function SubPageLayout() {
  return <Outlet />;
}
